import React from "react";

// Package Imports
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const ActiveStateCell: React.FC<{
  active_state: boolean;
}> = React.memo(({ active_state }) => {
  return (
    <div
      className={`pulse-display-f pulse-align-center pulse-typography-body-1`}
    >
      {active_state ? (
        <CheckCircleIcon className="pulse-mr-1" sx={{ color: "#119436" }} />
      ) : (
        <ErrorIcon className="pulse-mr-1" sx={{ color: "#b40811" }} />
      )}

      {active_state ? (
        <p className="pulse-color--success-700">Active</p>
      ) : (
        <p className="pulse-color--error-700">Not Active</p>
      )}
    </div>
  );
});

export default ActiveStateCell;
